import * as Yup from "yup";

const VerifyCodeFormSchema = () => {
  return Yup.object().shape({
    code: Yup.string()
      .required("Kod jest wymagany")
      .matches(/^\d{5}$/, "Kod musi składać się z 5 cyfr"),
  });
};

export default VerifyCodeFormSchema;
